import setValue from '../../shared/actions/setValue'

const setActiveHotel = (id, dispatch, { main }) => {
  const newResults = main.results.map((result) => {
    if (result.id === id) {
      return { ...result, active: true }
    }
    return { ...result, active: false }
  })
  dispatch(setValue('results', newResults))
}

export default hotel => (dispatch, getState) => setActiveHotel(hotel.id, dispatch, getState())
